import { Link } from "react-router-dom";
import MarketingPage from "../marketing-page";
import BlogsDatabase from "./blogs-database";

const Blogs = () => {
    return (
        <MarketingPage>
            <h1 className="">
                Blog
            </h1>
            <div className="case-studies-container">
                {BlogsDatabase.map((blog) =>
                    <Link className="no-highlight case-studies-item" to={`blogs/${blog.slug}`}>
                        <img className="case-study-image" src={blog.mainImage}></img>
                        <div className="case-study-name">{blog.date}</div>
                        <h3>{blog.title}</h3>
                    </Link>
                )}
            </div>
        </MarketingPage>
    );
}

export default Blogs;